import { useEffect, useState } from 'react';

import { useAnalytics } from '@/services/analytics';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import { useDetectAdBlock } from 'adblock-detect-react';

const useAppAnalytics = () => {
    const mixpanel = useAnalytics();
    const [appVisitReported, setAppVisitReported] = useState(false);
    const [adBlockerReported, setAdBlockerReported] = useState(false);

    const { loading: userSettingsLoading, userSettings } = useUserSettings();
    const adBlockDetected = useDetectAdBlock();

    useEffect(() => {
        if (!userSettingsLoading && !appVisitReported) {
            mixpanel?.track('app', { event: 'view', editorVersion: userSettings?.features?.editor?.version });
            setAppVisitReported(true);
        }
    }, [userSettings?.features?.editor?.version, appVisitReported, userSettingsLoading]);

    useEffect(() => {
        if (adBlockDetected && !adBlockerReported) {
            mixpanel?.track('ad-blocker', { enabled: true });
            setAdBlockerReported(true);
        }
    }, [adBlockDetected]);
};

export default useAppAnalytics;
